import { FormattedMessage } from 'react-intl';

export const userAvatarMessages = {
  'userAvatar.menu.account.label': (
    <FormattedMessage
      id="userAvatar.menu.account.label"
      defaultMessage="Account"
    />
  ),
  'userAvatar.menu.switchSociety.label': (
    <FormattedMessage
      id="userAvatar.menu.switchSociety.label"
      defaultMessage="Switch society"
    />
  ),
  'userAvatar.menu.tests.label': (
    <FormattedMessage id="userAvatar.menu.tests.label" defaultMessage="Tests" />
  ),
  'userAvatar.menu.logout.label': (
    <FormattedMessage
      id="userAvatar.menu.logout.label"
      defaultMessage="Log out"
    />
  ),
};
